export default "__VITE_ASSET__CT3iq9tn__"